import { Input, EventEmitter, Directive } from '@angular/core';
import { Subscription } from 'rxjs';

import { SortEvent } from '../../domain/data-table.domain';
import { TableSort } from '../../components/datatable/types/sort.type';
import { SortByOption } from '../sort-by-selector/sort-by-selector.domain';
import { TableStateService } from './table-state.service';

@Directive()
export abstract class TableStateBaseDirective  {
  @Input('tdWbTableStateSubState') subState?: string;
  @Input('tdWbTableStateDefault') defaultState: TableSort;

  protected stateId: string;
  protected readonly sortChangeSubscription: Subscription = Subscription.EMPTY;

  protected constructor(protected tableStateService: TableStateService, sortChange: EventEmitter<SortByOption | SortEvent>) {
    this.sortChangeSubscription = sortChange.subscribe((sort: SortByOption | SortEvent): void => {
      this.onSort(sort);
    });
  }

  protected destroy(): void {
    this.sortChangeSubscription.unsubscribe();
  }

  protected getSorts(): Array<TableSort> {
    const sorts = this.tableStateService.getSorts(this.stateId, this.subState);
    return sorts === undefined ? this.getDefaultSorts() : sorts;
  }

  protected setSorts(sorts: Array<TableSort>): void {
    this.tableStateService.setSorts(this.stateId, this.subState, sorts);
  }

  protected getDefaultSorts(): Array<TableSort> {
    return this.defaultState === undefined ? undefined : [this.defaultState];
  }

  protected abstract onSort(sort: SortByOption | SortEvent): void;
}
